import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";

import * as actions from "../../../store/actions";
import "./index.css";

const NudgePermission = ({
  nudgePermission,
  setNudgePermission,
  updateNudgePermission,
  getNudgePermission,
}) => {
  useEffect(() => {
    getNudgePermission();
  }, [getNudgePermission]);
  return (
    <div>
      <p className="DBSubTitle mb-4">Nudge Permission</p>
      <p>
        Following permission allows your patients to nudge you when you are
        offline.
        <br />
        You can be online so they can connect with you.{" "}
      </p>
      <div className="custom-switch custom-switch-md left">
        <input
          type="checkbox"
          className="custom-control-input"
          id="customSwitches"
          onChange={e => {
            setNudgePermission({
              nudge_permission: e.target.checked,
            });
            updateNudgePermission();
          }}
          checked={nudgePermission.nudge_permission}
        />
        <label
          className="custom-control-label"
          htmlFor="customSwitches"
          style={{
            fontSize: 16,
          }}
        >
          <span>Allow patient to nudge</span>
        </label>
      </div>
    </div>
  );
};

const mapStoreToProps = ({ settings }) => ({
  nudgePermission: settings.nudgePermission,
});

const mapDispatchToProps = dispatch => ({
  setNudgePermission: updatedData =>
    dispatch(actions.setNudgePermission(updatedData)),
  updateNudgePermission: () => dispatch(actions.updateNudgePermission()),
  getNudgePermission: () => dispatch(actions.getNudgePermission()),
});

export default withRouter(
  connect(mapStoreToProps, mapDispatchToProps)(NudgePermission)
);
